<template>
    <v-card flat class="prog-board" ref="fullscreenRoot">
        <!-- ===================== KPIs ===================== -->
        <div class="prog-kpis" v-if="false">
            <article class="kpi">
                <p class="kpi-val">{{ fmtNum(kpis.ordenes) }}</p>
                <p class="kpi-lbl">Órdenes</p>
            </article>
            <article class="kpi">
                <p class="kpi-val">{{ fmtNum(kpis.maquinas) }}</p>
                <p class="kpi-lbl">Máquinas</p>
            </article>
            <article class="kpi">
                <p class="kpi-val">{{ avance.porcentaje }}%</p>
                <p class="kpi-lbl">% Avance</p>
            </article>
            <!-- <article class="kpi kpi--ok">
                <p class="kpi-val">{{ fmtNum(kpis.trabajando) }}</p>
                <p class="kpi-lbl">Trabajando</p>
            </article>
            <article class="kpi kpi--bad">
                <p class="kpi-val">{{ fmtNum(kpis.enParo) }}</p>
                <p class="kpi-lbl">En paro</p>
            </article> -->
            <article class="kpi">
                <p class="kpi-val">{{ fmtNum(kpis.sinOdt) }}</p>
                <p class="kpi-lbl">Sin ODT</p>
            </article>
            <article class="kpi">
                <p class="kpi-val">{{ fmtNum(avance.piezasObjetivo) }}</p>
                <p class="kpi-lbl">Piezas prog.</p>
            </article>
            <article class="kpi">
                <p class="kpi-val">{{ fmtNum(avance.piezasOk) }}</p>
                <p class="kpi-lbl">Producidas</p>
            </article>
        </div>

        <!-- ===================== TOOLBAR ===================== -->
        <div class="prog-toolbar">
            <span class="auto-refresh" :class="{ 'is-loading': cargando }"
                title="Actualización automática cada 5 minutos">
                <v-icon small :class="{ 'spin': cargando }">mdi-autorenew</v-icon>
                {{ cargando ? 'Actualizando…' : `Actualiza en ${restanteTexto}` }}
            </span>
            <v-btn small outlined color="primary" class="pp-fs-btn" @click="toggleFullscreen"
                :title="esFullscreen ? 'Salir de pantalla completa' : 'Pantalla completa'">
                <v-icon left small>{{ esFullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}</v-icon>
                {{ esFullscreen ? 'Salir' : 'Pantalla completa' }}
            </v-btn>
        </div>

        <!-- ===================== FILTROS ===================== -->
        <div class="prog-filtros">
            <div class="f-field f-date">
                <label>Inicio</label>
                <VueCtkDateTimePicker v-model="filtros.inicio" :disabled="cargando" :max-date="filtros.fin || undefined"
                    format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" first-day-of-week="1" noHeader overlay
                    locale="es" label="Fecha" button-now-translation="Ahora" />
            </div>
            <div class="f-field f-date">
                <label>Fin</label>
                <VueCtkDateTimePicker v-model="filtros.fin" :disabled="cargando" :min-date="filtros.inicio || undefined"
                    format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" first-day-of-week="1" noHeader overlay
                    locale="es" label="Fecha" button-now-translation="Ahora" />
            </div>
            <div class="f-field f-grow">
                <label>Áreas</label>
                <v-autocomplete v-model="filtros.idsArea" :items="catAreas" multiple chips small-chips deletable-chips
                    clearable dense outlined hide-details :disabled="cargando" placeholder="Todas" />
            </div>
            <div v-if="gamemode" class="f-field f-grow">
                <label>Instancias</label>
                <v-autocomplete v-model="filtros.idsInstancia" :items="catInstancias" multiple chips small-chips
                    deletable-chips clearable dense outlined hide-details :disabled="cargando" placeholder="Todas" />
            </div>
            <div v-if="gamemode" class="f-field f-grow">
                <label>Órdenes de trabajo</label>
                <v-autocomplete v-model="filtros.idsTrabajoOrden" :items="catOrdenes" multiple chips small-chips
                    deletable-chips clearable dense outlined hide-details :disabled="cargando" placeholder="Todas" />
            </div>
            <v-btn small color="primary" class="f-aplicar" :loading="cargando" @click="cargar">
                <v-icon left small>mdi-magnify</v-icon> Buscar
            </v-btn>
        </div>
        <div class="prog-export">
            <v-btn text small color="primary" class="prog-export-btn"
                :disabled="!filas.length || cargando || descargando" :loading="descargando"
                @click="descargarExcel">
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Descargar Excel
            </v-btn>
        </div>

        <div v-show="filas.length > 0" class="prog-legend prog-legend--top">
            <span class="lg"><i class="sw" style="background:#d9dee4; border:1px solid #c2c9d1" /> Plan (programado)</span>
            <span v-for="(b, i) in bandasLeyenda" :key="i" class="lg">
                <i class="sw" :style="{ background: b.color }" /> {{ b.etiqueta || rangoBandaLeyenda(i) }}
            </span>
        </div>

        <!-- ===================== TABLA + GANTT ===================== -->
        <div v-if="cargando && !tablero" class="prog-empty">Cargando tablero…</div>
        <div v-else-if="error" class="prog-empty">No fue posible cargar el tablero.</div>
        <div v-else-if="filas.length === 0" class="prog-empty">Sin órdenes para mostrar.</div>

        <div v-show="filas.length > 0" class="prog-grid">
            <!-- Franja superior fija: encabezados de columna + eje de tiempo (sticky al scrollear) -->
            <div class="prog-head-band">
                <div class="pt-head" :style="{ height: headH + 'px', width: tablaAncho + 'px' }">
                    <span class="c-maq">Maq</span>
                    <span class="c-molde">Molde</span>
                    <span class="c-avance">Producidas / Prog.</span>
                    <span class="c-num">Rate</span>
                    <span class="c-num">Hrs</span>
                    <span class="c-num">H.Falt</span>
                    <span class="c-ot">OT</span>
                </div>
                <div class="prog-gantt prog-gantt--eje" ref="graficaEje" :style="{ height: headH + 'px' }" />
            </div>

            <!-- Cuerpo: filas de datos (izquierda) + barras del Gantt (derecha) -->
            <div class="prog-body-band">
                <div class="prog-table" :style="{ width: tablaAncho + 'px' }">
                    <div v-for="(f, i) in filas" :key="i" class="pt-row pt-row--click"
                        :class="{ 'pt-row--group': f.primeraDeGrupo }" :style="{ height: rowH + 'px' }"
                        title="Ver comparación programado vs real" @click="abrirOdt(f)">
                        <span class="c-maq">
                            <span v-if="f.primeraDeGrupo" class="maq-chip-wrap"
                                :style="{ height: f.groupRows * rowH + 'px' }">
                                <span class="maq-chip" :class="`maq-chip--${f.estadoMaquina}`">{{ f.maquina }}</span>
                            </span>
                        </span>
                        <span class="c-molde">
                            <v-icon small class="molde-flag" :style="{ color: f.colorHex }">mdi-flag</v-icon>
                            {{ f.molde || '—' }}
                        </span>
                        <span class="c-avance" :title="`${fmtNum(f.prod)} producidas / ${fmtNum(f.prog)} programadas`">
                            <b class="av-ok">{{ fmtNum(f.prod) }}</b>
                            <span class="av-sep">/</span>
                            <span class="av-obj">{{ fmtNum(f.prog) }}</span>
                        </span>
                        <span class="c-num">{{ f.rate ? fmtNum(f.rate) : '—' }}</span>
                        <span class="c-num" title="Horas transcurridas desde el inicio real de la ODT">{{ f.hrs ? f.hrs : '—' }}</span>
                        <span class="c-num" title="Horas faltantes (promedio de operaciones de la ODT)">{{ f.hFalt || '—' }}</span>
                        <span class="c-ot" :title="f.ot">{{ f.ot || '—' }}</span>
                    </div>
                </div>

                <!-- Línea de tiempo (derecha) -->
                <div class="prog-gantt" ref="grafica" :style="{ height: bodyH + 'px' }" />
            </div>
        </div>

        <!-- Dialog de detalle de fragmento -->
        <v-dialog v-model="dialogFragmento" max-width="520">
            <v-card class="frag-card">
                <v-card-title class="frag-title">
                    <i class="frag-dot" :style="{ background: fragmento.colorHex }" />
                    <span>ODT {{ fragmento.clave }}</span>
                    <v-spacer />
                    <span class="frag-banda" :style="{ color: fragmento.colorHex }">{{ fragmento.banda }}</span>
                </v-card-title>
                <v-divider />
                <v-card-text class="pt-3">
                    <div class="frag-sec">Identificación</div>
                    <div class="frag-grid">
                        <div class="frag-row"><span>Máquina</span><b>{{ fragmento.maquina }}</b></div>
                        <div class="frag-row"><span>Área</span><b>{{ fragmento.area }}</b></div>
                        <div class="frag-row"><span>Molde</span><b>{{ fragmento.molde }}</b></div>
                        <div class="frag-row frag-row--wide"><span>Artículo</span><b>{{ fragmento.articulo }}</b></div>
                    </div>

                    <div class="frag-sec">Tiempos</div>
                    <div class="frag-grid">
                        <div class="frag-row"><span>Inicio</span><b>{{ fragmento.inicio }}</b></div>
                        <div class="frag-row"><span>Fin</span><b>{{ fragmento.fin }}</b></div>
                        <div class="frag-row"><span>Duración</span><b>{{ fragmento.duracion }}</b></div>
                        <div class="frag-row"><span>TC programado</span><b>{{ fragmento.tc ? fragmento.tc + ' s/pza' :
                                '—'
                                }}</b></div>
                    </div>

                    <div class="frag-sec">Producción</div>
                    <div class="frag-grid">
                        <div class="frag-row"><span>Programadas</span><b>{{ fmtNum(fragmento.objetivo) }} pzas</b></div>
                        <div class="frag-row"><span>Producidas OK</span><b>{{ fmtNum(fragmento.ok) }} pzas</b></div>
                        <div class="frag-row"><span>Faltantes</span><b>{{ fmtNum(fragmento.faltantes) }} pzas</b></div>
                        <div class="frag-row">
                            <span>Cumplimiento</span>
                            <b :style="{ color: fragmento.colorHex }">{{ fragmento.cumplimiento }}%</b>
                        </div>
                    </div>

                    <div class="frag-progress">
                        <div class="frag-progress-bar">
                            <div class="frag-progress-fill"
                                :style="{ width: fragmento.cumplimientoBar + '%', background: fragmento.colorHex }" />
                        </div>
                        <span class="frag-progress-txt">{{ fmtNum(fragmento.ok) }} / {{ fmtNum(fragmento.objetivo)
                            }}</span>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" @click="dialogFragmento = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog de comparación Teórico vs Real de la ODT (clic en una fila de la tabla) -->
        <v-dialog v-model="dialogOdt" max-width="760">
            <v-card class="frag-card">
                <v-card-title class="frag-title">
                    <i class="frag-dot" :style="{ background: odt.colorHex }" />
                    <span>ODT {{ odt.clave }}</span>
                    <v-spacer />
                    <span class="frag-banda" :style="{ color: odt.colorHex }">
                        {{ odt.iniciada ? 'En producción' : 'Sin iniciar' }}
                    </span>
                </v-card-title>
                <v-divider />
                <v-card-text class="pt-3">
                    <div class="frag-sec">Identificación</div>
                    <div class="frag-grid">
                        <div class="frag-row"><span>Máquina</span><b>{{ odt.maquina }}</b></div>
                        <div class="frag-row"><span>Área</span><b>{{ odt.area }}</b></div>
                        <div class="frag-row"><span>Molde</span><b>{{ odt.molde }}</b></div>
                        <div class="frag-row frag-row--wide"><span>Artículo</span><b>{{ odt.articulo }}</b></div>
                    </div>

                    <div class="frag-sec">Programado vs Real</div>
                    <table class="cmp-table">
                        <thead>
                            <tr><th>Métrica</th><th>Programado</th><th>Real</th></tr>
                        </thead>
                        <tbody>
                            <tr><td>Inicio</td><td>{{ odt.inicioTeo }}</td><td>{{ odt.inicioReal }}</td></tr>
                            <tr><td>Fin</td><td>{{ odt.finTeo }}</td><td>{{ odt.finReal }}</td></tr>
                            <tr><td>Tiempo</td><td>{{ odt.durTeo }}</td><td>{{ odt.avanceReal }}</td></tr>
                            <tr><td>Piezas</td><td>{{ fmtNum(odt.objetivo) }}</td><td>{{ fmtNum(odt.ok) }}</td></tr>
                            <tr><td>Rate (pz/h)</td><td>{{ fmtNum(odt.rate) }}</td><td>{{ fmtNum(odt.rate) }}</td></tr>
                            <tr><td>Tiempo faltante</td><td>—</td><td>{{ odt.faltanteProm }}</td></tr>
                            <tr v-if="odt.desfase !== '—'">
                                <td>Desfase</td><td>—</td>
                                <td :style="{ color: odt.colorHex }">{{ odt.desfase }} ({{ odt.desfasePct }}%)</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="frag-progress">
                        <div class="frag-progress-bar">
                            <div class="frag-progress-fill"
                                :style="{ width: odt.cumplimientoBar + '%', background: odt.colorHex }" />
                        </div>
                        <span class="frag-progress-txt">{{ fmtNum(odt.ok) }} / {{ fmtNum(odt.objetivo) }} ·
                            {{ odt.cumplimiento }}%</span>
                    </div>

                    <div class="frag-sec">Operaciones (cavidades)</div>
                    <table class="cmp-table cmp-table--ops">
                        <thead>
                            <tr>
                                <th>Art.</th><th>TC</th><th>Rate</th><th>Prog.</th><th>OK</th>
                                <th>No OK</th><th>Falt.</th><th>T. falt</th><th>Inicio real</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="op in odt.operaciones" :key="op.id">
                                <td>{{ op.codigo }}</td>
                                <td>{{ op.tc }}</td>
                                <td>{{ fmtNum(op.rate) }}</td>
                                <td>{{ fmtNum(op.esperadas) }}</td>
                                <td>{{ fmtNum(op.ok) }}</td>
                                <td>{{ fmtNum(op.noOk) }}</td>
                                <td>{{ fmtNum(op.faltantesPz) }}</td>
                                <td>{{ op.tFalt }}</td>
                                <td>{{ op.inicioReal }}</td>
                            </tr>
                            <tr v-if="!odt.operaciones || !odt.operaciones.length">
                                <td colspan="9" class="cmp-empty">Sin operaciones</td>
                            </tr>
                        </tbody>
                    </table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" @click="dialogOdt = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'

const COLOR = {
    planFill: '#dcf0d6',
    planBorde: '#7cbd74',
    planTexto: '#2f6e2b',
    ahora: '#c0392b',
    finJornada: '#1f78d1',
    // Línea punteada de inicio de turno (hora de arranque) por día.
    arranque: '#5b6570',
    // Barra teórica (plan) en gris.
    teoricaFill: '#d9dee4',
    teoricaBorde: '#c2c9d1',
    teoricaTexto: '#5b6570',
}

const BANDA_COLOR = {
    verde: '#63b46a',
    amarillo: '#f0ac22',
    naranja: '#e67e22',
    rojo: '#d64545',
}

// Gris para ODTs sin operaciones reales (no iniciadas): la bandera no refleja desfase aún.
const GRIS_SIN_REAL = '#9aa4ad'

// Bandas de desfase por defecto (fallback para la leyenda si el tablero no las trae). El backend
// (config r100) es la fuente real; esto coincide con BandasDesfaseDefault.
const BANDAS_DESFASE_DEFAULT = [
    { hasta: 10, color: '#63b46a', etiqueta: '0%–10% (en meta)' },
    { hasta: 15, color: '#f0ac22', etiqueta: '10%–15% desfase' },
    { hasta: null, color: '#d64545', etiqueta: '>15% desfase' },
]

// Color de la bandera/estado de una ODT: gris si no ha iniciado (sin operación real); en otro
// caso, el color de su desfase de tiempo (el que asigna el backend a la barra real).
const colorBandera = (iniciada, colorReal) => {
    if (!iniciada) return GRIS_SIN_REAL
    // El backend manda el color hex ya resuelto (banda de desfase configurable).
    if (typeof colorReal === 'string' && colorReal.charAt(0) === '#') return colorReal
    return BANDA_COLOR[colorReal] || BANDA_COLOR.verde
}

const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb']
const DIAS_LARGO = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']

// Lee una propiedad aceptando camelCase o PascalCase (el backend serializa en Pascal).
const prop = (obj, camel) => {
    if (!obj) return undefined
    if (obj[camel] !== undefined) return obj[camel]
    const pascal = camel.charAt(0).toUpperCase() + camel.slice(1)
    return obj[pascal]
}

const toMs = (iso) => {
    if (!iso) return NaN
    const t = new Date(iso).getTime()
    return Number.isNaN(t) ? NaN : t
}

// Color de la barra. El backend manda el color hex resuelto (banda de desfase configurable);
// si no, se cae al mapa de claves o al cálculo por piezas (compatibilidad).
const colorBanda = (ok, objetivo, colorBackend) => {
    if (typeof colorBackend === 'string' && colorBackend.charAt(0) === '#') return colorBackend
    if (colorBackend && BANDA_COLOR[colorBackend]) return BANDA_COLOR[colorBackend]
    if (!objetivo || objetivo <= 0) return BANDA_COLOR.verde
    const pct = (Math.max(0, objetivo - ok) * 100) / objetivo
    if (pct <= 1) return BANDA_COLOR.verde
    if (pct <= 10) return BANDA_COLOR.amarillo
    if (pct <= 15) return BANDA_COLOR.naranja
    return BANDA_COLOR.rojo
}

const bandaTexto = (ok, objetivo, colorBackend) => {
    const map = { verde: 'En meta', amarillo: '1%–10% desfase', naranja: '10%–15% desfase', rojo: '>15% desfase' }
    if (colorBackend && map[colorBackend]) return map[colorBackend]
    if (!objetivo || objetivo <= 0) return 'En meta'
    const pct = (Math.max(0, objetivo - ok) * 100) / objetivo
    if (pct <= 1) return 'En meta'
    if (pct <= 10) return '1%–10% desfase'
    if (pct <= 15) return '10%–15% desfase'
    return '>15% desfase'
}

const fmtNum = (n) => Number(n || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 })

const fmtDuracion = (seg) => {
    const s = Math.max(0, Math.round(Number(seg) || 0))
    const h = Math.floor(s / 3600)
    const m = Math.floor((s % 3600) / 60)
    if (h > 0) return `${h} h ${m} min`
    if (m > 0) return `${m} min`
    return `${s} s`
}

const fmtFechaHora = (ms) => {
    const d = new Date(ms)
    const p = (n) => String(n).padStart(2, '0')
    return `${DIAS[d.getDay()]} ${d.getDate()} ${MESES[d.getMonth()]} ${p(d.getHours())}:${p(d.getMinutes())}`
}

export default {
    name: 'ReporteAvanceProduccion',

    props: {
        active: { type: Boolean, default: false },
    },

    data() {
        return {
            chart: null,
            // Chart independiente para la franja del eje de tiempo (fija en la parte superior).
            chartEje: null,
            resizeHandler: null,
            cargando: false,
            descargando: false,
            error: false,
            tablero: null,
            filtros: { inicio: '', fin: '', idsArea: [], idsTrabajoOrden: [], idsInstancia: [] },
            // Hora de arranque del turno (de /Horarios). Se dibuja como línea punteada por día.
            horaArranque: null,
            dialogFragmento: false,
            fragmento: {},
            dialogOdt: false,
            odt: {},
            esFullscreen: false,
            fsHandler: null,
            // Auto-actualización (igual que en ReportePlanDeProduccionV3): la cuenta
            // regresiva dispara la recarga al llegar a 0; cada recarga la reinicia.
            intervaloSeg: 300,
            restante: 300,
            timerTick: null,
            // Geometría de la cuadrícula (px). Cada fila mide rowH; el encabezado headH.
            rowH: 47,
            headH: 56,
            tablaAncho: 616,
        }
    },

    computed: {
        gamemode() {
            return localStorage.getItem('gamemode') === 'true'
        },

        maquinas() {
            return (this.tablero && (prop(this.tablero, 'maquinas') || [])) || []
        },

        catAreas() {
            return this.catalogoItems('areas')
        },

        catInstancias() {
            return this.catalogoItems('instancias')
        },

        catOrdenes() {
            return this.catalogoItems('ordenesTrabajo')
        },

        restanteTexto() {
            const s = Math.max(0, this.restante)
            const m = Math.floor(s / 60)
            return `${m}:${String(s % 60).padStart(2, '0')}`
        },

        avance() {
            const a = (this.tablero && prop(this.tablero, 'avance')) || {}
            return {
                porcentaje: Number(prop(a, 'porcentaje') || 0),
                piezasOk: Number(prop(a, 'piezasOk') || 0),
                piezasObjetivo: Number(prop(a, 'piezasObjetivo') || 0),
            }
        },

        // Bandas para la leyenda: las que aplicó el backend (tablero.bandasDesfase) o el default.
        bandasLeyenda() {
            const delTablero = prop(this.tablero, 'bandasDesfase')
            const bandas = Array.isArray(delTablero) && delTablero.length ? delTablero : BANDAS_DESFASE_DEFAULT
            return bandas.map((b) => ({
                color: prop(b, 'color'),
                etiqueta: prop(b, 'etiqueta'),
                hasta: prop(b, 'hasta'),
            }))
        },

        areaTitulo() {
            // Si todas las barras pertenecen a una sola área, se muestra en el título.
            const areas = new Set()
            this.maquinas.forEach((m) => {
                ; (prop(m, 'barrasTeoricas') || []).forEach((b) => {
                    const a = prop(b, 'area')
                    if (a) areas.add(a)
                })
            })
            return areas.size === 1 ? [...areas][0] : ''
        },

        subtitulo() {
            const ini = toMs(`${this.filtros.inicio}T00:00:00`)
            const fin = toMs(`${this.filtros.fin}T00:00:00`)
            if (!Number.isFinite(ini) || !Number.isFinite(fin)) return 'línea de tiempo teórica por molde'
            const di = new Date(ini)
            const df = new Date(fin)
            const rango = `${di.getDate()}–${df.getDate()} ${MESES[di.getMonth()]} ${di.getFullYear()}`
            return `Semana ${rango} · línea de tiempo teórica por molde`
        },

        // Estado de cada máquina: trabajando (real en curso), paro (debería producir ahora
        // pero no lo hace), o libre (sin ODT asignada en el periodo).
        estadosMaquina() {
            const ahora = Date.now()
            const map = {}
            this.maquinas.forEach((m) => {
                const reales = prop(m, 'barrasReales') || []
                const teoricas = prop(m, 'barrasTeoricas') || []
                const trabajando = reales.some((b) => prop(b, 'enCurso'))
                const planActiva = teoricas.some((b) => {
                    const ini = toMs(prop(b, 'inicio'))
                    const f = toMs(prop(b, 'fin'))
                    return Number.isFinite(ini) && Number.isFinite(f) && ahora >= ini && ahora < f
                })
                let estado = 'libre'
                if (trabajando) estado = 'ok'
                else if (teoricas.length > 0) estado = planActiva ? 'paro' : 'libre'
                map[prop(m, 'idMaquina')] = estado
            })
            return map
        },

        // Una fila por barra teórica (ODT), agrupadas por máquina. El filtrado por área,
        // instancia y ODT lo aplica el backend con los ids de los filtros. La primera fila
        // de cada grupo lleva groupRows (nº de filas de la máquina) para centrar su etiqueta.
        filas() {
            const out = []
            this.maquinas.forEach((m) => {
                const etiqueta = prop(m, 'modeloMaquina') || prop(m, 'nombreMaquina') || `#${prop(m, 'idMaquina')}`
                // Piezas OK reales por ODT (mismo avance que muestran las barras reales en V3).
                // La barra teórica no trae producción, así que el avance se toma de las reales.
                const realOkPorOdt = {}
                const realBarPorOdt = {}
                ;(prop(m, 'barrasReales') || []).forEach((rb) => {
                    const id = prop(rb, 'idTrabajoOrden')
                    if (id == null) return
                    realOkPorOdt[id] = (realOkPorOdt[id] || 0) + Number(prop(rb, 'piezasOk') || 0)
                    realBarPorOdt[id] = rb
                })

                const barras = (prop(m, 'barrasTeoricas') || [])
                    .slice()
                    .sort((a, b) => toMs(prop(a, 'inicio')) - toMs(prop(b, 'inicio')))

                const grupo = barras.map((b) => {
                    const ini = toMs(prop(b, 'inicio'))
                    const fin = toMs(prop(b, 'fin'))
                    const prog = Number(prop(b, 'piezasObjetivo') || 0)
                    const idOdt = prop(b, 'idTrabajoOrden')
                    const prodOk = realOkPorOdt[idOdt] != null
                        ? realOkPorOdt[idOdt]
                        : Number(prop(b, 'piezasOk') || 0)
                    // Horas avanzadas y faltantes por ODT, desde la barra real (segundos → horas).
                    const rb = realBarPorOdt[idOdt]
                    const segAvance = rb ? Number(prop(rb, 'segundosAvance') || 0) : 0
                    const segFalt = rb ? Number(prop(rb, 'segundosFaltantePromedio') || 0) : 0
                    // Bandera: gris si la ODT no tiene operación real; si no, el color de su desfase.
                    const iniciada = !!prop(b, 'iniciada')
                    return {
                        idMaquina: prop(m, 'idMaquina'),
                        maquina: etiqueta,
                        estadoMaquina: this.estadosMaquina[prop(m, 'idMaquina')] || 'libre',
                        primeraDeGrupo: false,
                        groupRows: 0,
                        molde: prop(b, 'molde'),
                        articulo: prop(b, 'articulo'),
                        prog,
                        prod: prodOk,
                        // Bandera: gris si no hay operación real; si no, color del desfase (barra real).
                        colorHex: colorBandera(iniciada, rb ? prop(rb, 'color') : null),
                        falt: Math.max(0, prog - prodOk),
                        rate: Math.round(Number(prop(b, 'ratePromedio') || 0)),
                        hrs: segAvance > 0 ? +(segAvance / 3600).toFixed(1) : 0,
                        hFalt: segFalt > 0 ? +(segFalt / 3600).toFixed(1) : 0,
                        ot: String(prop(b, 'clave') || ''),
                        inicioMs: ini,
                        finMs: fin,
                        raw: b,
                        rawReal: rb || null,
                    }
                })
                if (grupo.length) {
                    grupo[0].primeraDeGrupo = true
                    grupo[0].groupRows = grupo.length
                }
                out.push(...grupo)
            })
            return out
        },

        totalFilas() {
            let n = 0
            this.maquinas.forEach((m) => {
                n += (prop(m, 'barrasTeoricas') || []).length
            })
            return n
        },

        kpis() {
            const estados = this.estadosMaquina
            let trabajando = 0
            let enParo = 0
            let sinOdt = 0
            this.maquinas.forEach((m) => {
                const e = estados[prop(m, 'idMaquina')]
                if (e === 'ok') trabajando += 1
                else if (e === 'paro') enParo += 1
                if (!(prop(m, 'barrasTeoricas') || []).length) sinOdt += 1
            })
            return {
                ordenes: this.totalFilas,
                maquinas: this.maquinas.length,
                trabajando,
                enParo,
                sinOdt,
            }
        },

        // Alto del cuerpo del Gantt (sin el encabezado, que ahora vive en su propio chart fijo).
        bodyH() {
            return this.filas.length * this.rowH
        },
    },

    watch: {
        active(val) {
            if (val) {
                if (!this.tablero) this.cargar()
                else this.$nextTick(() => this.render())
                this.iniciarAutoActualizacion()
            } else {
                this.detenerAutoActualizacion()
            }
        },
        filas() {
            this.$nextTick(() => this.render())
        },
    },

    async mounted() {
        this.resizeHandler = () => {
            if (this.chart) this.chart.resize()
            if (this.chartEje) this.chartEje.resize()
        }
        window.addEventListener('resize', this.resizeHandler)
        this.fsHandler = () => this.syncFullscreen()
        document.addEventListener('fullscreenchange', this.fsHandler)
        document.addEventListener('webkitfullscreenchange', this.fsHandler)
        // Ajusta el rango por defecto con los horarios activos antes de la primera carga.
        await this.inicializarDesdeHorarios()
        if (this.active || !this.tablero) this.cargar()
        if (this.active) this.iniciarAutoActualizacion()
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler)
        document.removeEventListener('fullscreenchange', this.fsHandler)
        document.removeEventListener('webkitfullscreenchange', this.fsHandler)
        this.detenerAutoActualizacion()
        if (this.chart) {
            this.chart.dispose()
            this.chart = null
        }
        if (this.chartEje) {
            this.chartEje.dispose()
            this.chartEje = null
        }
    },

    methods: {
        fmtNum,

        // Pantalla completa de todo el reporte (la tarjeta raíz), igual que en V3.
        toggleFullscreen() {
            const root = this.$refs.fullscreenRoot
            const el = root && root.$el ? root.$el : root
            if (!el) return
            const doc = document
            const enFs = doc.fullscreenElement || doc.webkitFullscreenElement
            if (!enFs) {
                if (el.requestFullscreen) el.requestFullscreen()
                else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
            } else {
                if (doc.exitFullscreen) doc.exitFullscreen()
                else if (doc.webkitExitFullscreen) doc.webkitExitFullscreen()
            }
        },

        syncFullscreen() {
            const doc = document
            const fsEl = doc.fullscreenElement || doc.webkitFullscreenElement
            const root = this.$refs.fullscreenRoot
            const el = root && root.$el ? root.$el : root
            this.esFullscreen = !!fsEl && fsEl === el
            // El cambio de pantalla completa no dispara resize de window: re-ajustar las gráficas.
            this.$nextTick(() => {
                if (this.chart) this.chart.resize()
                if (this.chartEje) this.chartEje.resize()
            })
        },

        // Texto de rango para la leyenda cuando la banda no tiene etiqueta propia.
        rangoBandaLeyenda(i) {
            const bandas = this.bandasLeyenda
            const desde = i === 0 ? 0 : (Number(bandas[i - 1].hasta) || 0)
            const hasta = bandas[i].hasta
            return hasta == null ? `>${desde}% desfase` : `${desde}%–${hasta}% desfase`
        },

        // Convierte el catálogo del backend (camel/Pascal) a items {text, value}.
        catalogoItems(clave) {
            const cat = prop(this.tablero, 'catalogos') || {}
            const lista = prop(cat, clave) || []
            return lista.map((it) => ({ text: prop(it, 'nombre'), value: prop(it, 'id') }))
        },

        reiniciarContador() {
            this.restante = this.intervaloSeg
        },

        // Tick de 1 s: descuenta el contador y dispara la recarga al llegar a 0.
        // No descuenta mientras hay una carga en curso para no encimar peticiones.
        iniciarAutoActualizacion() {
            this.detenerAutoActualizacion()
            this.reiniciarContador()
            this.timerTick = setInterval(() => {
                if (this.cargando) return
                if (this.restante <= 1) this.cargar()
                else this.restante -= 1
            }, 1000)
        },

        detenerAutoActualizacion() {
            if (this.timerTick) {
                clearInterval(this.timerTick)
                this.timerTick = null
            }
        },

        // Lunes (00:00) de la semana en curso.
        lunesSemanaActual() {
            const hoy = new Date()
            const diff = (hoy.getDay() + 6) % 7 // lunes = 0
            const lunes = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())
            lunes.setDate(lunes.getDate() - diff)
            return lunes
        },

        // Formatea una fecha al formato del picker: "YYYY-MM-DD HH:mm".
        fmtFiltro(d) {
            const p = (n) => String(n).padStart(2, '0')
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
        },

        // Convierte el valor del picker ("YYYY-MM-DD HH:mm" o "YYYY-MM-DD") a ISO para el query.
        filtroAIso(v) {
            if (!v) return v
            const s = String(v).trim().replace(' ', 'T')
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00:00`
            if (/T\d{2}:\d{2}$/.test(s)) return `${s}:00`
            return s
        },

        // Fallback síncrono: semana en curso (lunes 00:00 → lunes siguiente 00:00).
        inicializarSemana() {
            const inicio = this.lunesSemanaActual()
            const fin = new Date(inicio)
            fin.setDate(inicio.getDate() + 7)
            this.filtros.inicio = this.fmtFiltro(inicio)
            this.filtros.fin = this.fmtFiltro(fin)
        },

        // Calcula el rango por defecto a partir de los horarios activos (CAT_Horarios):
        // toma el día con menor diaSemana (0=domingo … 6=sábado) y su hora de inicio,
        // ubicándolo en su última ocurrencia en o antes de hoy; el fin es ese mismo
        // punto una semana después.
        async inicializarDesdeHorarios() {
            try {
                // /Horarios responde { events, start, intervals }: los horarios están en events.
                const { data } = await axios.get('/Horarios')
                const horarios = Array.isArray(data)
                    ? data
                    : Array.isArray(data && data.events)
                        ? data.events
                        : []
                if (!horarios.length) {
                    this.inicializarSemana()
                    return
                }

                const menor = horarios.reduce((min, h) =>
                    Number(prop(h, 'diaSemana')) < Number(prop(min, 'diaSemana')) ? h : min,
                )
                const diaSemana = Number(prop(menor, 'diaSemana'))
                const [hh, mm] = String(prop(menor, 'inicio') || '00:00').split(':').map(Number)
                // Guarda la hora de arranque del turno para dibujar la línea punteada por día.
                this.horaArranque = { hh: hh || 0, mm: mm || 0 }

                // Última ocurrencia de ese día de la semana en o antes de hoy
                // (0=domingo … 6=sábado), p. ej. domingo → el último domingo desde hoy.
                const hoy = new Date()
                const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())
                const diff = (inicio.getDay() - diaSemana + 7) % 7
                inicio.setDate(inicio.getDate() - diff)
                inicio.setHours(hh || 0, mm || 0, 0, 0)

                const fin = new Date(inicio)
                fin.setDate(inicio.getDate() + 7)

                this.filtros.inicio = this.fmtFiltro(inicio)
                this.filtros.fin = this.fmtFiltro(fin)
            } catch (e) {
                // Si falla, se usa el fallback de la semana en curso.
                this.inicializarSemana()
                // eslint-disable-next-line no-console
                console.error('Error cargando horarios para fechas por defecto', e)
            }
        },

        async cargar() {
            // Toda recarga (manual o automática) reinicia el contador.
            this.reiniciarContador()
            // Garantiza que el rango (con la hora de arranque del turno) esté resuelto antes de
            // consultar: si un disparo temprano (auto-refresh o cambio de pestaña durante la
            // carga inicial de /Horarios) llega con los filtros vacíos, se sale sin inicio/fin.
            if (!this.filtros.inicio || !this.filtros.fin) {
                await this.inicializarDesdeHorarios()
            }
            this.cargando = true
            this.error = false
            try {
                const p = new URLSearchParams()
                if (this.filtros.inicio) p.append('inicio', this.filtroAIso(this.filtros.inicio))
                if (this.filtros.fin) p.append('fin', this.filtroAIso(this.filtros.fin))
                    ; (this.filtros.idsArea || []).forEach((v) => p.append('idsArea', v))
                    ; (this.filtros.idsTrabajoOrden || []).forEach((v) => p.append('idsTrabajoOrden', v))
                    ; (this.filtros.idsInstancia || []).forEach((v) => p.append('idsInstancia', v))
                const { data } = await axios.get(`/ReportesMoldes/TableroProduccionV4?${p.toString()}`)
                this.tablero = data
                this.$nextTick(() => this.render())
            } catch (e) {
                this.error = true
                // eslint-disable-next-line no-console
                console.error('Error cargando tablero de avance de producción', e)
            } finally {
                this.cargando = false
            }
        },

        datos() {
            const filas = this.filas
            let minMs = Infinity
            let maxMs = -Infinity

            const teoricas = []
            const reales = []
            // Mapa idMaquina|idTrabajoOrden -> índice de fila, para ubicar las barras reales.
            const idxPorOdt = {}

            filas.forEach((f, idx) => {
                const idOdt = prop(f.raw, 'idTrabajoOrden')
                if (idOdt != null) idxPorOdt[`${f.idMaquina}|${idOdt}`] = idx
                const ini = f.inicioMs
                const fin = f.finMs
                if (Number.isNaN(ini) || Number.isNaN(fin) || fin <= ini) return
                minMs = Math.min(minMs, ini)
                maxMs = Math.max(maxMs, fin)
                teoricas.push({
                    value: [idx, ini, fin, f.ot, f.prod, f.prog, f.colorHex, f.molde || ''],
                    raw: f.raw,
                    fila: f,
                })
            })

            // Barras reales: un fragmento por producción real, ubicado en la fila de su ODT.
            // Solo se dibujan cuando tienen producción (piezasOk > 0).
            this.maquinas.forEach((m) => {
                const idMaquina = prop(m, 'idMaquina')
                ;(prop(m, 'barrasReales') || []).forEach((rb) => {
                    const ok = Number(prop(rb, 'piezasOk') || 0)
                    if (ok <= 0) return
                    const idx = idxPorOdt[`${idMaquina}|${prop(rb, 'idTrabajoOrden')}`]
                    if (idx == null) return
                    const ini = toMs(prop(rb, 'inicio'))
                    const fin = toMs(prop(rb, 'fin'))
                    if (Number.isNaN(ini) || Number.isNaN(fin) || fin <= ini) return
                    minMs = Math.min(minMs, ini)
                    maxMs = Math.max(maxMs, fin)
                    const obj = Number(prop(rb, 'piezasObjetivo') || 0)
                    reales.push({
                        value: [idx, ini, fin, prop(rb, 'clave') || '', ok, obj,
                            colorBanda(ok, obj, prop(rb, 'color')), prop(rb, 'molde') || ''],
                        raw: rb,
                        fila: filas[idx],
                    })
                })
            })

            if (!Number.isFinite(minMs) || !Number.isFinite(maxMs)) {
                const ahora = Date.now()
                minMs = ahora - 12 * 3600 * 1000
                maxMs = ahora + 12 * 3600 * 1000
            }

            const margen = 60 * 60 * 1000
            return {
                n: filas.length,
                teoricas,
                reales,
                min: minMs - margen,
                max: maxMs + margen,
            }
        },

        render() {
            if (!this.tablero) return
            const el = this.$refs.grafica
            const elEje = this.$refs.graficaEje
            if (!el || !elEje || !this.filas.length) return
            const datos = this.datos()
            if (!this.chart) this.chart = echarts.init(el)
            if (!this.chartEje) this.chartEje = echarts.init(elEje)
            this.chart.resize()
            this.chartEje.resize()
            this.chart.setOption(this.crearOption(datos), true)
            this.chartEje.setOption(this.crearOptionEje(datos), true)
            // Comparten grupo para sincronizar el zoom/scroll horizontal: al hacer zoom en el
            // cuerpo, el eje fijo se mueve igual (y viceversa).
            const grupo = `avanceProd-${this._uid}`
            this.chart.group = grupo
            this.chartEje.group = grupo
            echarts.connect(grupo)
            this.$nextTick(() => {
                if (this.chart) this.chart.resize()
                if (this.chartEje) this.chartEje.resize()
            })
        },

        // Eje X de tiempo común a ambos charts (cuerpo y franja fija). `conEtiquetas` controla si
        // se dibujan las etiquetas de días/horas (solo en la franja superior).
        ejeTiempo(datos, conEtiquetas) {
            return {
                type: 'time',
                position: 'top',
                min: datos.min,
                max: datos.max,
                axisLabel: {
                    show: conEtiquetas,
                    color: '#283139',
                    fontWeight: 700,
                    formatter: (value) => {
                        const d = new Date(value)
                        if (d.getHours() === 0 && d.getMinutes() === 0) {
                            return `{dia|${DIAS_LARGO[d.getDay()]}}\n{fecha|${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}}`
                        }
                        return `{hora|${String(d.getHours()).padStart(2, '0')}}`
                    },
                    rich: {
                        dia: { fontWeight: 800, fontSize: 13, color: '#283139', padding: [0, 0, 2, 0] },
                        fecha: { fontWeight: 600, fontSize: 10.5, color: '#6b7682' },
                        hora: { fontWeight: 600, fontSize: 11, color: '#97a0aa' },
                    },
                },
                // Sin líneas de cuadrícula por día (las 00:00): solo se muestran las líneas
                // punteadas de la hora de arranque del turno.
                splitLine: { show: false },
                axisLine: { show: conEtiquetas, lineStyle: { color: '#bdbdbd' } },
                axisTick: { show: false },
            }
        },

        // Puntos (uno por día visible) en la hora de arranque del turno, para dibujar la línea
        // punteada de inicio de jornada. Devuelve [] si no se conoce la hora de arranque.
        lineasArranque(min, max) {
            if (!this.horaArranque || !Number.isFinite(min) || !Number.isFinite(max)) return []
            const { hh, mm } = this.horaArranque
            const out = []
            const d = new Date(min)
            d.setHours(hh, mm, 0, 0)
            if (d.getTime() < min) d.setDate(d.getDate() + 1)
            // Tope de seguridad por si el rango fuera enorme.
            for (let i = 0; i < 60 && d.getTime() <= max; i++) {
                out.push({ xAxis: d.getTime() })
                d.setDate(d.getDate() + 1)
            }
            return out
        },

        // Opción del chart de la FRANJA FIJA: solo el eje de tiempo (días/horas) y las líneas
        // verticales de referencia (Ahora / Fin Jornada) para que se vean continuas con el cuerpo.
        crearOptionEje(datos) {
            const ahora = Date.now()
            const mostrarAhora = ahora >= datos.min && ahora <= datos.max
            const finJornada = toMs(prop(this.tablero, 'fechaFinJornada'))
            const mostrarFin = Number.isFinite(finJornada) && finJornada >= datos.min && finJornada <= datos.max

            return {
                backgroundColor: '#fff',
                animation: false,
                // El grid ocupa solo la franja inferior del encabezado: arriba van las etiquetas.
                grid: { left: 0, right: 14, top: 44, bottom: 0 },
                dataZoom: [{ type: 'inside', xAxisIndex: 0, filterMode: 'none' }],
                xAxis: this.ejeTiempo(datos, true),
                yAxis: { type: 'value', min: 0, max: 1, show: false },
                series: [
                    {
                        name: 'ArranqueEje', type: 'line', data: [], silent: true,
                        markLine: {
                            symbol: 'none', label: { show: false },
                            lineStyle: { color: COLOR.arranque, type: 'dotted', width: 1.5 },
                            data: this.lineasArranque(datos.min, datos.max),
                        },
                    },
                    {
                        name: 'AhoraEje', type: 'line', data: [], silent: true,
                        markLine: {
                            symbol: 'none', label: { show: false },
                            lineStyle: { color: COLOR.ahora, type: 'dashed', width: 2 },
                            data: mostrarAhora ? [{ xAxis: ahora }] : [],
                        },
                    },
                    {
                        name: 'FinEje', type: 'line', data: [], silent: true,
                        markLine: {
                            symbol: 'none', label: { show: false },
                            lineStyle: { color: COLOR.finJornada, type: 'solid', width: 3 },
                            data: mostrarFin ? [{ xAxis: finJornada }] : [],
                        },
                    },
                ],
            }
        },

        crearOption(datos) {
            const ahora = Date.now()
            const mostrarAhora = ahora >= datos.min && ahora <= datos.max
            const finJornada = toMs(prop(this.tablero, 'fechaFinJornada'))
            const mostrarFin = Number.isFinite(finJornada) && finJornada >= datos.min && finJornada <= datos.max

            return {
                backgroundColor: '#fff',
                animation: false,

                tooltip: {
                    trigger: 'item',
                    borderColor: '#e6e9ed',
                    formatter: (params) => {
                        const v = params.value || []
                        const esReal = params.seriesName === 'Real'
                        const ok = Number(v[4] || 0)
                        const obj = Number(v[5] || 0)
                        const raw = (params.data && params.data.raw) || {}
                        const lineas = [
                            `<b>${esReal ? 'Real' : 'Plan programado'} · ${v[7] || 'Molde'}</b>`,
                            `ODT: ${v[3]}`,
                            `Inicio: ${fmtFechaHora(v[1])}`,
                            `Fin: ${fmtFechaHora(v[2])}`,
                        ]
                        if (esReal) {
                            const banda = prop(raw, 'bandaEtiqueta') || bandaTexto(ok, obj, prop(raw, 'color'))
                            lineas.push(`Piezas: ${fmtNum(ok)} / ${fmtNum(obj)}`)
                            lineas.push(
                                `<span style="display:inline-block;width:10px;height:10px;border-radius:2px;` +
                                `background:${colorBanda(ok, obj, prop(raw, 'color'))};margin-right:5px;vertical-align:middle"></span>${banda}`
                            )
                        } else {
                            lineas.push(`Programadas: ${fmtNum(obj)} pz`)
                        }
                        return lineas.join('<br/>')
                    },
                },

                // El cuerpo arranca en y=0: el encabezado ya no vive aquí, sino en el chart fijo.
                grid: { left: 0, right: 14, top: 0, bottom: 0 },

                dataZoom: [{ type: 'inside', xAxisIndex: 0, filterMode: 'none' }],

                // Mismo eje de tiempo que la franja fija, pero sin etiquetas (solo líneas guía).
                xAxis: this.ejeTiempo(datos, false),

                yAxis: {
                    type: 'category',
                    inverse: true,
                    data: Array.from({ length: datos.n }, (_, i) => i),
                    show: false,
                    axisTick: { show: false },
                    axisLine: { show: false },
                    splitLine: { show: false },
                    axisLabel: { show: false },
                },

                series: [
                    {
                        name: 'Teorica',
                        type: 'custom',
                        encode: { x: [1, 2], y: 0 },
                        data: datos.teoricas,
                        renderItem: this.renderTeorica,
                    },
                    {
                        name: 'Real',
                        type: 'custom',
                        z: 3,
                        encode: { x: [1, 2], y: 0 },
                        data: datos.reales,
                        renderItem: this.renderReal,
                    },
                    {
                        name: 'Arranque',
                        type: 'line',
                        data: [],
                        silent: true,
                        markLine: {
                            symbol: 'none',
                            label: { show: false },
                            lineStyle: { color: COLOR.arranque, type: 'dotted', width: 1.5 },
                            data: this.lineasArranque(datos.min, datos.max),
                        },
                    },
                    {
                        name: 'Ahora',
                        type: 'line',
                        data: [],
                        silent: true,
                        markLine: {
                            symbol: 'none',
                            label: {
                                show: mostrarAhora,
                                formatter: 'Ahora',
                                color: '#fff',
                                backgroundColor: COLOR.ahora,
                                padding: [3, 7],
                                borderRadius: 3,
                                fontWeight: 700,
                            },
                            lineStyle: { color: COLOR.ahora, type: 'dashed', width: 2 },
                            data: mostrarAhora ? [{ xAxis: ahora }] : [],
                        },
                    },
                    {
                        name: 'Fin Jornada',
                        type: 'line',
                        data: [],
                        silent: true,
                        markLine: {
                            symbol: 'none',
                            label: {
                                show: mostrarFin,
                                formatter: 'Fin Jornada',
                                color: '#fff',
                                backgroundColor: COLOR.finJornada,
                                padding: [3, 7],
                                borderRadius: 3,
                                fontWeight: 700,
                            },
                            lineStyle: { color: COLOR.finJornada, type: 'solid', width: 3 },
                            data: mostrarFin ? [{ xAxis: finJornada }] : [],
                        },
                    },
                ],
            }
        },

        renderTeorica(params, api) {
            return this.renderFila(params, api, 'teorica')
        },

        renderReal(params, api) {
            return this.renderFila(params, api, 'real')
        },

        // Dibuja una barra dentro de la fila, ambas en una sola línea (centradas verticalmente):
        // la teórica (gris) como marco del plan y la real (color de su avance) encima, más
        // delgada, como relleno de avance.
        renderFila(params, api, tipo) {
            const cat = api.value(0)
            const p0 = api.coord([api.value(1), cat])
            const p1 = api.coord([api.value(2), cat])
            const rowH = api.size([0, 1])[1]
            const ancho = p1[0] - p0[0]
            const esTeorica = tipo === 'teorica'
            const barH = esTeorica ? rowH * 0.46 : rowH * 0.30
            const y = p0[1] - barH / 2

            const rect = echarts.graphic.clipRectByRect(
                { x: p0[0], y, width: ancho, height: barH },
                { x: params.coordSys.x, y: params.coordSys.y, width: params.coordSys.width, height: params.coordSys.height }
            )
            if (!rect) return null

            const children = [
                {
                    type: 'rect',
                    shape: { x: rect.x, y: rect.y, width: rect.width, height: rect.height, r: 4 },
                    // La real es semitransparente para que la teórica (gris) se vea debajo.
                    style: esTeorica
                        ? { fill: COLOR.teoricaFill, stroke: COLOR.teoricaBorde, lineWidth: 1 }
                        : { fill: api.value(6), opacity: 0.7 },
                },
            ]

            return { type: 'group', children }
        },

        onClickFragmento(p) {
            if (p.seriesName !== 'Teorica' && p.seriesName !== 'Real') return
            const esReal = p.seriesName === 'Real'
            const v = p.value || []
            const raw = (p.data && p.data.raw) || {}
            const fila = (p.data && p.data.fila) || {}

            const objetivo = Number(v[5] || 0)
            const ok = Number(v[4] || 0)
            const cumplimiento = objetivo > 0 ? Math.round((ok / objetivo) * 100) : 0
            const durSeg = Math.max(0, Math.round((v[2] - v[1]) / 1000))

            this.fragmento = {
                tipo: esReal ? 'Real' : 'Plan teórico',
                clave: prop(raw, 'clave') || v[3] || '—',
                maquina: fila.maquina || '—',
                area: prop(raw, 'area') || '—',
                molde: prop(raw, 'molde') || v[7] || '—',
                articulo: prop(raw, 'articulo') || '—',
                inicio: fmtFechaHora(v[1]),
                fin: fmtFechaHora(v[2]),
                duracion: fmtDuracion(durSeg),
                tc: Number(prop(raw, 'tc') || 0),
                objetivo,
                ok,
                faltantes: Math.max(0, objetivo - ok),
                cumplimiento,
                cumplimientoBar: Math.min(100, cumplimiento),
                colorHex: colorBanda(ok, objetivo, prop(raw, 'color')),
                banda: prop(raw, 'bandaEtiqueta') || bandaTexto(ok, objetivo, prop(raw, 'color')),
            }
            this.dialogFragmento = true
        },

        // Comparación Teórico vs Real de una ODT (clic en una fila de la tabla). Combina la barra
        // teórica (f.raw) con la real (f.rawReal). La real puede no existir si la ODT no ha iniciado.
        abrirOdt(f) {
            const teo = f.raw || {}
            const real = f.rawReal || null

            const idTrabajoOrden = Number(prop(teo, 'idTrabajoOrden') || 0)
            const iniciada = !!real
            const objetivo = Number(prop(teo, 'piezasObjetivo') || 0)
            const ok = real ? Number(prop(real, 'piezasOk') || 0) : 0
            const noOk = real ? Number(prop(real, 'piezasNoOk') || 0) : 0

            const iniTeoMs = toMs(prop(teo, 'inicio'))
            const finTeoMs = toMs(prop(teo, 'fin'))
            const iniRealIso = real ? (prop(real, 'inicioReal') || prop(real, 'inicio')) : null
            const finRealMs = real ? toMs(prop(real, 'fin')) : NaN

            // Duración teórica: la que expone la barra real (referencia del plan) o, en su defecto,
            // fin − inicio de la teórica. Tiempo real avanzado = segundosAvance.
            const durTeoSeg = real && prop(real, 'duracionTeoricaSegundos') != null
                ? Number(prop(real, 'duracionTeoricaSegundos'))
                : (Number.isFinite(iniTeoMs) && Number.isFinite(finTeoMs)
                    ? Math.round((finTeoMs - iniTeoMs) / 1000) : 0)
            const segAvance = real ? Number(prop(real, 'segundosAvance') || 0) : 0
            const segFalt = real ? Number(prop(real, 'segundosFaltantePromedio') || 0) : 0
            const desfaseSeg = real ? Number(prop(real, 'desfaseSegundos') || 0) : 0
            const desfasePct = real ? Number(prop(real, 'desfasePorcentaje') || 0) : 0

            // Operaciones combinadas por IdOperacion (esperadas/tc/rate del teórico; ok/noOk/faltante
            // del real). Se parte del teórico para listar todas las cavidades planeadas.
            const realPorOp = {}
            ;(real ? (prop(real, 'operaciones') || []) : []).forEach((o) => {
                realPorOp[prop(o, 'idOperacion')] = o
            })
            const operaciones = (prop(teo, 'operaciones') || []).map((o) => {
                const id = prop(o, 'idOperacion')
                const r = realPorOp[id] || {}
                const esp = Number(
                    prop(o, 'piezasEsperadas') ||
                    prop(o, 'cantidad') ||
                    prop(o, 'cantidadProgramada') ||
                    0
                )
                const tc = Number(prop(o, 'tc') || 0)
                const rateTeo = Number(prop(o, 'rate') || prop(o, 'ratePromedio') || (tc > 0 ? (3600 / tc) : 0))
                const durTeoOp = Number(
                    prop(o, 'duracionEsperadaSegundos') ||
                    prop(o, 'duracionTeoricaSegundos') ||
                    (tc > 0 && esp > 0 ? tc * esp : 0)
                )
                const opOk = Number(prop(r, 'piezasOk') || prop(o, 'piezasOk') || 0)
                const opNoOk = Number(prop(r, 'piezasNoOk') || prop(o, 'piezasNoOk') || 0)
                const iniOp = prop(r, 'inicioReal') || prop(r, 'inicio')
                const segFaltOp = Number(prop(r, 'segundosFaltante') || prop(o, 'segundosFaltante') || durTeoOp)
                return {
                    id,
                    codigo: prop(o, 'codigo') || prop(o, 'idArticulo') || '—',
                    tc,
                    rate: rateTeo,
                    esperadas: esp,
                    ok: opOk,
                    noOk: opNoOk,
                    totales: Number(prop(r, 'piezasTotales') || prop(o, 'piezasTotales') || 0),
                    faltantesPz: Math.max(0, esp - opOk),
                    tFalt: fmtDuracion(segFaltOp),
                    inicioReal: iniOp ? fmtFechaHora(toMs(iniOp)) : '—',
                }
            })

            const cumplimiento = objetivo > 0 ? Math.round((ok / objetivo) * 100) : 0
            const rate = Number(prop(teo, 'ratePromedio') || (real ? prop(real, 'ratePromedio') : 0) || 0)

            this.odt = {
                clave: prop(teo, 'clave') || '—',
                molde: prop(teo, 'molde') || '—',
                maquina: f.maquina || '—',
                area: prop(teo, 'area') || '—',
                articulo: prop(teo, 'articulo') || '—',
                iniciada,
                idTrabajoOrden,
                noIniciada: !iniciada && idTrabajoOrden > 0,
                inicioTeo: Number.isFinite(iniTeoMs) ? fmtFechaHora(iniTeoMs) : '—',
                inicioReal: iniRealIso ? fmtFechaHora(toMs(iniRealIso)) : '—',
                finTeo: Number.isFinite(finTeoMs) ? fmtFechaHora(finTeoMs) : '—',
                finReal: Number.isFinite(finRealMs) ? fmtFechaHora(finRealMs) : '—',
                durTeo: fmtDuracion(durTeoSeg),
                avanceReal: real ? fmtDuracion(segAvance) : '—',
                objetivo,
                ok,
                noOk,
                faltantesPz: Math.max(0, objetivo - ok),
                rate,
                faltanteProm: real ? fmtDuracion(segFalt) : '—',
                desfase: desfaseSeg > 0 ? fmtDuracion(desfaseSeg) : '—',
                desfasePct,
                cumplimiento,
                cumplimientoBar: Math.min(100, cumplimiento),
                colorHex: colorBandera(!!iniRealIso, real ? prop(real, 'color') : null),
                operaciones,
            }
            this.dialogOdt = true
        },

        descargarExcel() {
            if (this.descargando) return
            const params = new URLSearchParams()
            if (this.filtros.inicio) params.append('inicio', this.filtroAIso(this.filtros.inicio))
            if (this.filtros.fin) params.append('fin', this.filtroAIso(this.filtros.fin))
            ;(this.filtros.idsArea || []).forEach((v) => params.append('idsArea', v))
            ;(this.filtros.idsTrabajoOrden || []).forEach((v) => params.append('idsTrabajoOrden', v))
            ;(this.filtros.idsInstancia || []).forEach((v) => params.append('idsInstancia', v))

            this.descargando = true
            axios.get(`/ReportesMoldes/TableroProduccionV4Excel?${params.toString()}`, {
                responseType: 'blob',
            }).then((response) => {
                const contentDisposition = response.headers && response.headers['content-disposition']
                const match = contentDisposition && contentDisposition.match(/filename="?([^"]+)"?/i)
                const nombreArchivo = match ? match[1] : 'R104_AvanceProduccion.xlsx'
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                const url = URL.createObjectURL(blob)
                const enlace = document.createElement('a')
                enlace.href = url
                enlace.download = nombreArchivo
                document.body.appendChild(enlace)
                enlace.click()
                document.body.removeChild(enlace)
                URL.revokeObjectURL(url)
            }).catch((e) => {
                // eslint-disable-next-line no-console
                console.error('Error descargando Excel de avance de producción', e)
            }).finally(() => {
                this.descargando = false
            })
        },
    },
}
</script>

<style scoped>
.prog-board {
    --ink: #283139;
    --muted: #6b7682;
    --line: #e6e9ed;
    --blue: #2563d6;
    background: #fff;
    padding: 16px 18px 22px;
}

/* Pantalla completa: la tarjeta llena la pantalla y permite scroll del contenido. */
.prog-board:fullscreen,
.prog-board:-webkit-full-screen {
    background: #fff;
    overflow: auto;
    width: 100vw;
    height: 100vh;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.prog-board:fullscreen::backdrop {
    background: #fff;
}

.prog-board:-webkit-full-screen::backdrop {
    background: #fff;
}

.pp-fs-btn {
    height: 30px !important;
}

/* Encabezado */
.prog-head {
    display: flex;
    align-items: baseline;
    gap: 12px;
    flex-wrap: wrap;
}

.prog-title {
    font-size: 20px;
    font-weight: 800;
    color: var(--ink);
    margin: 0;
}

.prog-sub {
    font-size: 13px;
    font-weight: 600;
    color: var(--muted);
}

/* KPIs */
.prog-kpis {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    gap: 10px;
    margin: 14px 0;
}

.kpi {
    border: 1px solid var(--line);
    border-radius: 10px;
    background: #f7f9fc;
    padding: 10px 12px;
    text-align: left;
}

.kpi-val {
    font-size: 22px;
    font-weight: 800;
    color: var(--ink);
    margin: 0;
    line-height: 1.1;
}

.kpi-lbl {
    font-size: 10.5px;
    font-weight: 700;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: .03em;
    margin: 2px 0 0;
}

.kpi--ok {
    background: #eaf7ed;
    border-color: #bfe6c8;
}

.kpi--ok .kpi-val {
    color: #2e9e5b;
}

.kpi--bad {
    background: #fdecec;
    border-color: #f3c4c4;
}

.kpi--bad .kpi-val {
    color: #d64545;
}

/* Filtros */
.prog-filtros {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    padding: 10px 12px;
    border: 1px solid var(--line);
    background: #f7f9fc;
    border-radius: 10px;
}

.prog-export {
    display: flex;
    justify-content: flex-end;
    margin: 4px 2px 0;
}

.prog-export-btn {
    min-height: 24px !important;
    height: auto !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 600;
}

.f-field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 150px;
}

.f-field.f-grow {
    flex: 1;
    min-width: 200px;
}

/* Campos de fecha con hora: ancho suficiente para mostrar "YYYY-MM-DD HH:mm" completo. */
.f-field.f-date {
    min-width: 190px;
}

.f-field.f-date>>>.field-input {
    height: 40px !important;
    min-height: 40px !important;
    font-size: 13px;
}

.f-aplicar {
    align-self: flex-end;
    height: 40px;
}

.f-field label {
    font-size: 11px;
    font-weight: 700;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: .03em;
}

.f-field>>>.v-input {
    margin: 0;
    padding: 0;
    font-size: 13px;
}

.f-field>>>.v-input__control {
    min-height: 34px;
}

.f-spacer {
    flex: 1;
}

.f-check {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: var(--ink);
    cursor: pointer;
}

.f-count {
    font-size: 12px;
    font-weight: 700;
    color: var(--muted);
}

/* Toolbar + indicador de auto-actualización (igual que en ReportePlanDeProduccionV3) */
.prog-toolbar {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    margin: 14px 0 12px;
}

.auto-refresh {
    margin-right: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    font-weight: 700;
    color: var(--blue);
    background: #f0f5ff;
    border: 1px solid #d6e2ff;
    border-radius: 999px;
    padding: 5px 12px;
    white-space: nowrap;
}

.auto-refresh .v-icon {
    color: var(--blue);
}

.auto-refresh.is-loading {
    color: var(--muted);
    background: #f1f3f6;
    border-color: var(--line);
}

.auto-refresh .spin {
    animation: prog-spin 1s linear infinite;
}

@keyframes prog-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

/* Datepicker overrides (igual que en ReportePlanDeProduccionV3) */
.prog-date-picker>>>.v-btn--rounded {
    border-radius: 28px !important;
}

.prog-date-picker>>>.v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
    font-family: Roboto, sans-serif;
    font-weight: 500 !important;
    padding: 0;
}

.prog-date-picker>>>.v-date-picker-table .v-btn.v-btn--active {
    color: #fff !important;
}

.prog-date-picker>>>.accent {
    background-color: #005caf !important;
    border-color: #005caf !important;
}

.prog-date-picker>>>tbody tr:nth-of-type(odd) {
    background-color: transparent;
}

/* Cuadrícula: tabla (izq) + gantt (der), comparten alto de fila */
.prog-grid {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    margin-top: 14px;
    border: 1px solid var(--line);
    border-radius: 10px;
    /* Sin scroll propio: el contenido crece a su altura natural y solo desplaza la página. */
    overflow: visible;
}

/* Franja superior fija (encabezados de columna + eje de tiempo). Se queda pegada arriba al
   desplazar la página/tarjeta gracias a position: sticky. */
.prog-head-band {
    display: flex;
    align-items: stretch;
    position: sticky;
    top: 0;
    z-index: 6;
    background: #fff;
    border-bottom: 1px solid var(--line);
    border-radius: 10px 10px 0 0;
}

.prog-body-band {
    display: flex;
    align-items: stretch;
}

.prog-table {
    flex: 0 0 auto;
    border-right: 1px solid var(--line);
    background: #fff;
}

/* El encabezado de columnas comparte el borde derecho con la columna de datos y delega su
   borde inferior a la franja fija para no duplicar la línea. */
.prog-head-band .pt-head {
    flex: 0 0 auto;
    border-right: 1px solid var(--line);
    border-bottom: none;
}

.pt-head,
.pt-row {
    display: grid;
    grid-template-columns: 52px 100px 150px 48px 44px 52px 170px;
    align-items: center;
    font-size: 12px;
    color: var(--ink);
}

.pt-head {
    font-size: 11px;
    font-weight: 800;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: .02em;
    border-bottom: 1px solid var(--line);
    background: #f7f9fc;
}

.pt-head span,
.pt-row span {
    padding: 0 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.pt-row {
    border-bottom: 1px solid #f1f3f6;
}

.pt-row--group {
    border-top: 1px solid var(--line);
}

/* Fila clicable: abre el diálogo de comparación teórico vs real. */
.pt-row--click {
    cursor: pointer;
    transition: background .12s ease;
}

.pt-row--click:hover {
    background: #eef4fb;
}

.pt-row .c-num {
    text-align: right;
    font-variant-numeric: tabular-nums;
}

.pt-head .c-num {
    text-align: right;
}

.c-molde,
.c-ot {
    font-weight: 700;
}

/* Molde con bandera de estado a la izquierda. */
.c-molde {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.molde-flag {
    flex: 0 0 auto;
    font-size: 16px !important;
}

/* La clave de ODT siempre se muestra completa (sin recorte): se permite que el texto
   haga wrap dentro de la fila para listas de varias claves. Se usa .pt-head/.pt-row
   para ganarle en especificidad a la regla genérica `.pt-row span` (nowrap + ellipsis). */
.pt-head .c-ot,
.pt-row .c-ot {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    line-height: 1.15;
    word-break: break-word;
}

/* Avance en una sola columna: hechas (izq) / esperadas (der). */
.c-avance {
    display: inline-flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 4px;
    font-variant-numeric: tabular-nums;
}

.pt-head .c-avance {
    justify-content: flex-end;
    color: var(--muted);
}

.av-ok {
    font-weight: 800;
    color: var(--ink);
}

.av-sep {
    color: #c0c6cd;
}

.av-obj {
    font-weight: 600;
    color: var(--muted);
}

/* La etiqueta de máquina se centra verticalmente sobre todas las filas de su grupo:
   el contenedor (alto = groupRows * rowH) desborda hacia abajo desde la primera fila. */
.pt-row .c-maq {
    position: relative;
    overflow: visible;
    /* Ocupa todo el alto de la fila (la grilla centra el resto de celdas): así el chip
       absoluto arranca en el borde superior real de la fila y se centra sobre el grupo. */
    align-self: stretch;
}

.maq-chip-wrap {
    position: absolute;
    top: 0;
    left: 6px;
    display: flex;
    align-items: center;
    z-index: 2;
}

.maq-chip {
    display: inline-block;
    font-weight: 800;
    font-size: 12px;
    padding: 2px 7px;
    border-radius: 6px;
    background: #eef1f4;
    color: var(--ink);
}

.maq-chip--ok {
    background: #eaf7ed;
    color: #2e9e5b;
}

.maq-chip--paro {
    background: #fdecec;
    color: #d64545;
}

.prog-gantt {
    flex: 1 1 auto;
    min-width: 480px;
}

/* Leyenda */
.prog-legend {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
    margin-top: 12px;
    font-size: 12.5px;
    color: var(--muted);
}

.prog-legend--top {
    margin-top: 8px;
    margin-bottom: 10px;
}

.prog-legend .lg {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.prog-legend .sw {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    display: inline-block;
}

.prog-empty {
    padding: 40px 0;
    text-align: center;
    color: var(--muted);
    font-size: 14px;
}

/* Dialog de detalle */
.frag-card {
    border-radius: 12px;
}

.frag-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
}

.frag-dot {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 8px;
}

.frag-banda {
    font-size: 13px;
    font-weight: 700;
}

.frag-sec {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: .04em;
    color: var(--muted);
    margin: 14px 0 6px;
}

.frag-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px 18px;
}

.frag-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 13px;
    gap: 10px;
}

.frag-row span {
    color: var(--muted);
}

.frag-row--wide {
    grid-column: 1 / -1;
}

.frag-progress {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
}

.frag-progress-bar {
    flex: 1;
    height: 10px;
    border-radius: 6px;
    background: #eef1f4;
    overflow: hidden;
}

.frag-progress-fill {
    height: 100%;
    border-radius: 6px;
}

.frag-progress-txt {
    font-size: 12px;
    font-weight: 700;
    color: var(--ink);
    white-space: nowrap;
}

/* Tablas de comparación del diálogo de ODT. */
.cmp-table {
    width: 100%;
    border-collapse: collapse;
    margin: 6px 0 4px;
    font-size: 12.5px;
}

.cmp-table th,
.cmp-table td {
    padding: 6px 8px;
    text-align: left;
    border-bottom: 1px solid #f1f3f6;
}

.cmp-table thead th {
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: .02em;
    color: var(--muted);
    background: #f7f9fc;
    border-bottom: 1px solid var(--line);
}

.cmp-table td:first-child {
    font-weight: 700;
    color: var(--ink);
}

/* La tabla de operaciones es más densa y numérica. */
.cmp-table--ops {
    font-size: 12px;
}

.cmp-table--ops th,
.cmp-table--ops td {
    padding: 5px 6px;
    text-align: right;
    font-variant-numeric: tabular-nums;
}

.cmp-table--ops th:first-child,
.cmp-table--ops td:first-child,
.cmp-table--ops th:last-child,
.cmp-table--ops td:last-child {
    text-align: left;
}

.cmp-empty {
    text-align: center !important;
    color: var(--muted);
    font-style: italic;
}
</style>
